import { apiGetSignalsFiltered, apiGetSignals } from "@/Groups/Signals/private/api/signalsApi";

export const applyFilterWithToggle = async ({ state, dispatch }, filterName) => {
  if (state.activeFilter === filterName) {
    await dispatch("resetFilter");
    return;
  }

  await dispatch("applyFilter", filterName);
};

export const applyFilter = async ({ commit }, filterName) => {
  commit("TOGGLE_LOADING_FLAG", true);
  commit("SET_ACTIVE_SORT", null);
  commit("CHANGE_ACTIVE_FILTER", filterName);

  try {
    const data = await apiGetSignalsFiltered(filterName);
    commit("CLEAR_DATA");
    commit("SET_DATA", data.results);
    commit("SORT_SIGNALS");
    commit("SET_NEW_LINK", data.next || null);
  } catch (err) {
    console.error("Ошибка фильтрации:", err);
    throw err;
  } finally {
    commit("TOGGLE_LOADING_FLAG", false);
  }
};

export const resetFilter = async ({ commit, state }) => {
  if (state.activeFilter === null) return;

  commit("TOGGLE_LOADING_FLAG", true);
  commit("CHANGE_ACTIVE_FILTER", null);
  commit("SET_ACTIVE_SORT", null);

  try {
    const data = await apiGetSignals();
    commit("CLEAR_DATA");
    commit("SET_DATA", data.results);
    commit("SORT_SIGNALS");
    commit("SET_NEW_LINK", data.next);
  } catch (err) {
    console.error("Ошибка сброса фильтров:", err);
    throw err;
  } finally {
    commit("TOGGLE_LOADING_FLAG", false);
  }
};

export const resetFilterFlag = ({ commit }) => {
  commit("CHANGE_ACTIVE_FILTER", null);
};